import Icon from '../components/Icon.vue'

Icon.register({"shekel-sign":{"width":448,"height":512,"paths":[{"d":"M170.1 96H80V468C80 474.6 74.6 480 68 480H12C5.4 480 0 474.6 0 468V44C0 37.4 5.4 32 12 32H180.4C265.5 32 325 89.6 325 175.1V359C325 365.6 319.6 371 313 371H269C255.7 371 245 360.3 245 347V170.3C245 125.1 216.8 96 170.1 96zM436 32H380C373.4 32 368 37.4 368 44V416H277.9C231.2 416 203 386.9 203 341.7V165C203 151.7 192.3 141 179 141H135C128.4 141 123 146.4 123 153V336.9C123 422.4 182.5 480 267.6 480H436C442.6 480 448 474.6 448 468V44C448 37.4 442.6 32 436 32z"}]}})



//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-awesome/icons/shekel-sign.js
// module id = null
// module chunks = 